import { phase } from './homeMotion.js';

export const COAST_LOOP = { out: 2380, in: 3885 };

// The drawing dissolves directly into the full-colour frame. Both envelopes
// overlap so the image develops continuously while the final lines emerge.
const envelope = (time, start, end) => {
  const p = phase(time, start, end);
  return p * p * p * (p * (p * 6 - 15) + 10);
};

export function coastLoopAppearance(stage, elapsed) {
  if (stage === 'out') return {
    lines: 1 - envelope(elapsed, 1120, COAST_LOOP.out),
    image: 1 - envelope(elapsed, 0, 1960),
  };
  if (stage === 'in') return {
    lines: envelope(elapsed, 0, 2205),
    image: envelope(elapsed, 1365, COAST_LOOP.in),
  };
  const value = stage === 'idle' ? 1 : 0;
  return { lines: value, image: value };
}
